import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, FileText, FileSpreadsheet, Calculator, Users, Wallet, Key, BookOpen, RefreshCw, Store } from 'lucide-react';
const services = [{
  icon: <MessageSquare size={24} strokeWidth={1.5} data-id="element-121" />,
  title: 'Консультація перед стартом',
  description: 'Розповім, який облік підходить саме вам, з чого почати та як уникнути помилок на старті.',
  price: 'За домовленістю',
  buttonText: 'Записатись'
}, {
  icon: <FileText size={24} strokeWidth={1.5} data-id="element-122" />,
  title: 'Реєстрація ФОП',
  description: 'Допоможу швидко та правильно зареєструвати ФОП, обрати КВЕД та систему оподаткування.',
  price: 'За домовленістю',
  buttonText: 'Замовити'
}, {
  icon: <Calculator size={24} strokeWidth={1.5} data-id="element-123" />,
  title: 'Щомісячний бухгалтерський супровід',
  description: 'Повне ведення вашого ФОП: податки, звітність, контроль лімітів та консультації.',
  price: 'За домовленістю',
  buttonText: 'Замовити'
}, {
  icon: <Users size={24} strokeWidth={1.5} data-id="element-124" />,
  title: 'Зарплатно-кадровий облік',
  description: 'Оформлення працівників, розрахунок зарплати, відпускних, лікарняних та податків із зарплати.',
  price: 'За домовленістю',
  buttonText: 'Замовити'
}, {
  icon: <RefreshCw size={24} strokeWidth={1.5} data-id="element-125" />,
  title: 'Внесення змін по ФОП',
  description: 'Зміна КВЕДів, адреси, групи єдиного податку чи інших реєстраційних даних.',
  price: 'За домовленістю',
  buttonText: 'Замовити'
}, {
  icon: <Store size={24} strokeWidth={1.5} data-id="element-126" />,
  title: 'Реєстрація ПРРО',
  description: 'Допомога у виборі, реєстрації та налаштуванні програмного РРО для вашого бізнесу.',
  price: 'За домовленістю',
  buttonText: 'Замовити'
}, {
  icon: <BookOpen size={24} strokeWidth={1.5} data-id="element-127" />,
  title: 'Консультації з ведення ФОП',
  description: 'Відповіді на ваші запитання щодо податків, лімітів, РРО та змін у законодавстві.',
  price: 'За домовленістю',
  buttonText: 'Записатись'
}, {
  icon: <FileSpreadsheet size={24} strokeWidth={1.5} data-id="element-128" />,
  title: 'Подання звітності',
  description: 'Підготовка та подання всіх видів звітності вчасно. Без штрафів і прострочень.',
  price: 'За домовленістю',
  buttonText: 'Замовити'
}];
export function Services() {
  return <section id="services" className="py-24 bg-surface" data-id="element-129">
      <div className="max-w-7xl mx-auto px-6" data-id="element-130">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-semibold" data-id="element-132">Мої послуги</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-133">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-background rounded-3xl border border-border p-8 hover:border-primary/30 transition-colors duration-300 flex flex-col h-full" data-id="element-134">
              <div className="w-14 h-14 bg-surface rounded-2xl flex items-center justify-center text-primary mb-6 border border-border group-hover:scale-110 transition-transform duration-500" data-id="element-135">
                {service.icon}
              </div>

              <h3 className="text-xl font-semibold mb-3" data-id="element-136">{service.title}</h3>

              <p className="text-secondary text-sm leading-relaxed mb-8 flex-grow" data-id="element-137">
                {service.description}
              </p>

              <div className="mb-6 pt-5 border-t border-border" data-id="element-138">
                <div className="text-xs text-secondary uppercase tracking-wider mb-1 font-medium" data-id="element-139">
                  Вартість послуги
                </div>
                <div className="text-xl font-semibold text-primary" data-id="element-140">
                  {service.price}
                </div>
              </div>

              <a href="#contact" className="w-full py-3.5 bg-primary text-background rounded-xl font-medium hover:opacity-90 transition-opacity flex items-center justify-center text-sm" data-id="element-141">
                {service.buttonText}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}